import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useMarketplacePartnerRegisterPageContext } from '../marketplacePartnerRegisterPageContext'

type MarketplacePartnerRegisterPageFormMessagesProps = {
  errors?: boolean
}
export const MarketplacePartnerRegisterPageFormMessages: FC<
  MarketplacePartnerRegisterPageFormMessagesProps
> = ({ errors }) => {
  const { isFormSubmitted, isFormValid } =
    useMarketplacePartnerRegisterPageContext()

  return (
    <div
      className="flex items-center justify-center py-4"
      data-qa-id="marketplace-partner-register-page-submit-form-messages"
    >
      {errors ? (
        <p
          className="text-dark-error"
          data-qa-id="marketplace-partner-register-page-form-messages-error"
        >
          <FormattedMessage id="marketplacePartnerRegisterPage.form.error" />
        </p>
      ) : null}
      {isFormValid === false && (
        <p
          className="text-dark-error"
          data-qa-id="marketplace-partner-register-page-submit-form-messages-invalid"
        >
          <FormattedMessage id="marketplacePartnerRegisterPage.form.invalid" />
        </p>
      )}
      {isFormSubmitted && isFormValid ? (
        <p
          className="text-dark-success"
          data-qa-id="marketplace-partner-register-page-submit-form-messages-success"
        >
          <FormattedMessage id="marketplacePartnerRegisterPage.form.success" />
        </p>
      ) : null}
    </div>
  )
}
